import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { PenDto } from 'models/pen/Pen';

@autoinject
export class PenService {
  constructor(private client: NetlogHttpClient) {}

  async getPen(id: number) {
    return await this.client.get<PenDto>({
      url: `api/pen/get-pen/${id}`,
      model: PenDto,
    });
  }

  async generateJSON(id: number) {
    return await this.client.downloadBlob(`api/pen/generate-json/${id}`);
  }

  async createCertificate(id: number) {
    return await this.client.post({
      data: undefined,
      url: `api/pen/create-certificate/${id}`,
    });
  }

  async getCertificate(id: number) {
    return await this.client.downloadBlob(`api/pen/${id}/certificate/download`);
  }
}
